<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>México en el siglo XIX</h2>
    <img @click="imageClicked(0)" src="galerias/sala1/S1_G2.jpg" class="mainphoto"/>
    <p class="photo-description">Título: <b>Semana Santa en Cuautitlán</b><br>
      Autor: Primitivo Miranda<br>
      Año: 1858<br>
      Medidas: 57 cm x 71 cm<br>
      Técnica: Óleo sobre tela<br>
      Colección: Museo Nacional de Historia Castillo de Chapultepec<br>
      Documentos históricos, bandera y filatelia
    </p>
    <br>
    <p>Desde la Guerra de Independencia y hasta el último tercio del siglo XIX, México se vio envuelto en constantes luchas internas favorecidas a su vez por intervenciones extranjeras.</p>
    <p>Dos proyectos políticos divergentes trataron de consolidar su poder, uno, el de los conservadores quienes pretendían continuar con el Antiguo Régimen y orden social español bajo un gobierno centralista, monárquico y católico; otro, representado por los liberales quienes pugnaban por establecer una República Federal, de influencia estadounidense, con separación de poderes (legislativo, ejecutivo y judicial).</p>
    <h5>Ver más:</h5>
    <p>Imagen propiedad del Instituto Nacional de Antropología e Historia, para conocer más de la historia de este sitio visita: <a target="_blank" href="http://mediateca.inah.gob.mx/islandora_74/islandora/object/pintura:3988">mediateca.inah.gob.mx</a></p>
    <p>Si quieres conocer más sobre acontecimientos del Siglo XIX en México, visita: <a target="_blank" href="https://www.gob.mx/sre/acciones-y-programas/historia-del-siglo-xix">www.gob.mx</a></p>
    <p>Si quieres conocer más sobre las intervenciones extranjeras, visita: <a target="_blank" href="https://www.inah.gob.mx/red-de-museos/311-museo-nacional-de-las-intervenciones">www.inah.gob.mx</a></p>
    <h3>Estructura socioeconómica de México</h3>
    <img @click="imageClicked(1)" src="galerias/sala1/S1_G2_SUB.jpg" class="mainphoto"/>
    <p class="photo-description">Título: <b>Los Mexicanos pintados por sí mismos</b><br>
      Autor: Varios Autores<br>
      Año: 1854<br>
      Medidas: 22 x 4.5 x 29 cm<br>
      Técnica: Portada de libro en litografía<br>
      Colección: Biblioteca Nacional Digital de México IIB UNAM<br>
    </p>
    <br>
    <p>Durante el inicio del siglo XIX la estructura socioeconómica de México estaba compuesta por la clase dominante, clase media (profesionistas, mayordomos de haciendas, propietarios de tiendas y burócratas); artesanos y obreros, campesinos, así como los llamados “léperos”, quienes se dedicaban a la mendicidad y al robo.</p>
    <p>Durante este periodo las clases privilegiadas incrementaron su riqueza. La Iglesia había obtenido en este momento el control de la tercera parte de tierra cultivable y seguía siendo desde épocas anteriores el mayor garante de créditos y préstamos. En lo alto de la pirámide social estaban los grandes terratenientes, seguidos por los comerciantes e industriales, mineros y manufactureros, que en su mayoría eran ingleses, franceses y españoles.</p>
    <p>Los campesinos, indígenas en su mayoría, constituían gran parte de la población.</p>
    <h5>Ver más:</h5>
    <p>Si te interesa conocer más sobre las personas del Siglo XIX y la vida cotidiana, visita el libro “Los Mexicanos pintados por sí mismos”: <a target="_blank" href="https://catalogo.iib.unam.mx/F/-/?func=find-b&find_code=SYS&local_base=bndm&format=999&request=000046708">catalogo.iib.unam.mx</a></p>
  </div>
</template>

<script>
export default {
  name: "s12g02",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    },
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
